/* eslint-disable */
let debug = false;

let lastId = null;
let account = null;

function parseCookies() {
    const cookies = {};
    if (typeof document !== 'undefined' && document.cookie) {
        document.cookie.split(';').forEach((item) => {
            const parts = item.split('=');
            if (parts.length >= 2 && parts[0]) {
                cookies[parts[0].trim()] = parts.slice(1).join('=').trim();
            }
        });
    }
    return cookies;
}

function init(account_arg, userInfoCb) {
    account = account_arg;
    debug && console.log('fbp init', account);

    let scriptElement = null;

    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.9.140';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        scriptElement = t;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    let accumulatedInfo = localStorage.getItem('tracker.userInfo');
    accumulatedInfo = accumulatedInfo ? JSON.parse(accumulatedInfo) : {};
    let initArgs = {};
    if (accumulatedInfo.qntId) {
        initArgs.external_id = accumulatedInfo.qntId;
    }
    if (accumulatedInfo.fbp) {
        initArgs.fbp = accumulatedInfo.fbp;
    }
    if (accumulatedInfo.fbc) {
        initArgs.fbc = accumulatedInfo.fbc;
    }
    fbq('init', account, initArgs);
    fbq('track', 'PageView');

    // grab cookies safely with retry limit tied to script load & backoff
    let attempts = 0;
    const maxAttempts = 10;
    const expectsFbc = new URLSearchParams(window.location.search).has('fbclid');
    let lastReportedFbp = null;
    let lastReportedFbc = null;

    const reportCookies = (cookies) => {
        if (!cookies._fbp) {
            return false;
        }

        const fbc = cookies._fbc || null;
        if (cookies._fbp !== lastReportedFbp || fbc !== lastReportedFbc) {
            const params = {fbp: cookies._fbp};
            if (fbc) {
                params.fbc = fbc;
            }
            userInfoCb(params);
            lastReportedFbp = cookies._fbp;
            lastReportedFbc = fbc;
        }

        return true;
    };

    const checkCookies = () => {
        attempts += 1;
        const cookies = parseCookies();
        const hasFbp = reportCookies(cookies);
        if (hasFbp && (!expectsFbc || cookies._fbc)) {
            return;
        }

        if (attempts < maxAttempts) {
            const delay = Math.min(500 * attempts, 3000);
            setTimeout(checkCookies, delay);
        }
    };

    const initialCookies = parseCookies();
    reportCookies(initialCookies);

    if (scriptElement) {
        scriptElement.addEventListener('load', () => {
            attempts = 0;
            checkCookies();
        });
    } else if (!initialCookies._fbp || (expectsFbc && !initialCookies._fbc)) {
        checkCookies();
    }
}

function event(name) {
    debug && console.log('fbp event', name);
    fbq('trackCustom', name);
}

function hit(url) {
    debug && console.log('fbp hit', url);
    fbq('trackCustom', 'hit', {url: url});
}

let lastInfo = null;

const userInfo = function (info) {
    lastInfo = info;
    sendInfo();
};

let delayed = null;
function sendInfo() {
    if (delayed) {
        clearTimeout(delayed);
    }
    delayed = setTimeout(() => {
        debug && console.log('fbp info', lastInfo);

        let initArgs = {};
        if (lastInfo.qntId) {
            initArgs.external_id = lastInfo.qntId;
        }
        if (lastInfo.fbp) {
            initArgs.fbp = lastInfo.fbp;
        }
        if (lastInfo.fbc) {
            initArgs.fbc = lastInfo.fbc;
        }
        fbq('init', account, initArgs);

        const extInfo = {};
        Object.assign(extInfo, lastInfo);
        if (extInfo.qntId) {
            extInfo.external_id = extInfo.qntId;
        }

        fbq('trackCustom', 'info', extInfo);
        delayed = null;
    }, 5000);
}

export {init, event, hit, userInfo};
